// src/components/Footer.tsx
import React from "react";

const Footer: React.FC = () => {
  return (
    <>
      {/* =========================
          画面下部固定：4ボタン + ロゴ帯
          z-index を明示的に低くする
         ========================= */}
      <div className="footerDock" aria-label="footer dock">
        <div className="footerDock__inner">
          <nav className="footerNav" aria-label="footer navigation">
            <a className="footerBtn" href="/results" aria-label="実績一覧">
              <img src="/assets/member/footer-results.webp" alt="" />
            </a>
            <a className="footerBtn" href="/notices" aria-label="お知らせ">
              <img src="/assets/member/footer-notice.webp" alt="" />
            </a>
            <a className="footerBtn" href="/reviews" aria-label="レビュー">
              <img src="/assets/member/footer-review.webp" alt="" />
            </a>
            <a className="footerBtn" href="/contact" aria-label="お問い合わせ">
              <img src="/assets/member/footer-contact.webp" alt="" />
            </a>
          </nav>

          {/* ロゴ帯 */}
          <img
            className="footerDockLogo"
            src="/assets/member/LP-top11.webp"
            alt=""
          />
        </div>
      </div>

      {/* =========================
          通常フッター（固定しない）
         ========================= */}
      <footer className="footerLegal">
        <div className="footer-links">
          <a href="/terms">利用規約</a>
          <a href="/privacy">プライバシーポリシー</a>
          <a href="/law">特定商取引法</a>
          <a href="/faq">FAQ</a>
          <a href="/contact">お問い合わせ</a>
        </div>

        <div className="copyright">
          © {new Date().getFullYear()} BOAT億MAN All Rights Reserved.
        </div>
      </footer>

      {/* =========================
          ここから重要：z-index制御
         ========================= */}
      <style>{`
        /* footerDockは必ず低い層に */
        .footerDock {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 40; /* ← 低く固定（メニューより下） */
        }

        /* メニューが開いたとき用の保険 */
        body.menuOpen .footerDock {
          pointer-events: none; /* メニュー表示中はクリック不可 */
        }
      `}</style>
    </>
  );
};

export default Footer;